import React from 'react';
import { DataField, FormField } from '../interfaces/AppProps';

const validateValue = (value: string, typee: string, valueType: string): boolean => {
  // Updated: Require at least one digit after decimal point
  const stringRegex = /^[a-zA-Z0-9\s,""]*|^\s*$/;
  const numberRegex = /^-?\d+(\.\d+)?$/; // Changed \d{0,9} to \d+

  // Updated comparison regex to require digits after decimal
  const comparisonRegex = /^([><=]+)\s*(-?\d+(\.\d+)?)$|^=\s*(-?\d+(\.\d+)?)$/;
  const rangeRegex = /(\[|\])\s*(-?[\d.]+)?\s*to\s*(-?[\d.]+)?\s*(\]|\[)/;

  // Special case: if valueType is 'input', type is 'double', value contains '=' and all numbers, allow it
  if (
    valueType === 'input' &&
    typee === 'double' &&
    value.includes('=') &&
    value.replace(/=/g, '').replace(/\s/g, '').length > 0 &&
    value.replace(/=/g, '').replace(/\s/g, '').split(',').every(v => /^-?\d+(\.\d+)?$/.test(v) || v === '')
  ) {
    return true;
  }

  // NEW: if valueType is 'oinput', typee is 'double', and value is all numbers, allow it
  if (
    valueType === 'input' &&
    typee === 'double' &&
    value.replace(/\s/g, '').length > 0 &&
    value.replace(/\s/g, '').split(',').every(v => /^-?\d+(\.\d+)?$/.test(v) || v === '')
  ) {
    return true;
  }

  if (valueType === 'output') {
    if (typee === 'string') {
      return stringRegex.test(value);
    } else {
      return numberRegex.test(value)
    }
  }
  if (typee === 'string') {
    return stringRegex.test(value);
  }
  if (typee === 'double' && value?.match(/(\[|\])\s*(-?[\d.]+)?\s*to\s*(-?[\d.]+)?\s*(\]|\[)/)) {
    return rangeRegex.test(value)
  } else {
    return comparisonRegex.test(value)
  }
};

const validateData = (
  dmnData: DataField,
  headers: string[] | boolean,
  setValidationErrors: React.Dispatch<
    React.SetStateAction<{
      [key: string]: string;
    }>
  >
) => {
  const errors: { [key: string]: string } = {};
  dmnData?.data?.forEach((row: any, rowIndex: number) => {
    if (Array.isArray(headers)) {
      headers.forEach((header: any, colIndex: number) => {
        let valueType;
        const value = row[header]?.toString().trim().replace(/^"|"$/g, '');
        // Convert to string and trim spaces
        let fieldTypee = dmnData?.inputFields.find(
          (field: FormField) => field.name === header
        )?.type;
        let isVal = dmnData?.inputFields.find(
          (field: FormField) => field.name === header
        )
        if (isVal) {
          valueType = 'input'
        } else {
          valueType = 'output'
        }
        if (!fieldTypee) {
          fieldTypee = dmnData?.outputFields.find(
            (field: FormField) => field.name === header
          )?.type;
        }
        // Allow empty values for string fields
        if (value === '' && fieldTypee === 'string' && valueType !== 'output' && rowIndex === dmnData.data.length - 1) {
          return;
        } else if (value === '' && fieldTypee === 'double' && valueType !== 'output' && rowIndex === dmnData.data.length - 1) {
          return;
        }
        // New condition to check if valueType is 'output' and value is empty
        if (valueType === 'output' && value === '') {
          errors[`${rowIndex}-${colIndex}`] =
            ` Output value cannot be empty.`;
          return;
        }

        if (value && value.trim() !== '' && value.trim().toLowerCase() !== 'null') {
          if (fieldTypee === 'double' && !validateValue(value, fieldTypee, valueType)) {
            errors[`${rowIndex}-${colIndex}`] =
              ` Value must be a valid number or comparison.`;
          } else if (
            fieldTypee === 'string' &&
            !validateValue(value, fieldTypee, valueType)
          ) {
            errors[`${rowIndex}-${colIndex}`] =
              ` Value must be a valid string (only alphanumeric characters and commas allowed).`;
          }
        }
      });
    }
  });
  setValidationErrors(errors);
  return Object.keys(errors).length === 0;
};

export default validateData;
